function initContactForm(formElement){
  var formSubmit = formElement.getElementsByClassName('js-submit')[0];
  var messageElem = formElement.getElementsByClassName('js-message')[0];
  var url = formElement.getElementsByClassName('form-url')[0];

  var showMessage = function(message, type){
    messageElem.removeAttribute('hidden');

    messageElem.innerText = message;

    messageElem.classList.remove('error');
    if(type === 'error'){
      messageElem.classList.add('error');
    }

    setTimeout(function(){
      messageElem.setAttribute('hidden','hidden');
    }, 3000);
  };

  formElement.addEventListener('submit', function(event){
    event.preventDefault();

    formSubmit.setAttribute('disabled', 'disabled');
    formSubmit.innerText = 'Sending...';

    var xhr = new XMLHttpRequest();
    xhr.open('POST', url.value);
    xhr.send(new FormData(event.target));

    xhr.onload = function() {
      formSubmit.removeAttribute('disabled', 'disabled');
      formSubmit.innerText = 'Send message';

      if (xhr.status === 200) {
        var response = JSON.parse(xhr.responseText);
        if(response.ok){
          showMessage('Thank you for your messsage.','success');
          event.target.reset();
        }else{
          switch(response.message){
            case 'missing_email':showMessage('Please, check your email.','error');break;
            case 'missing_message':showMessage('Please, fill your message.','error');break;
          }
        }
      } else {
        showMessage('Something is broken, please try it later or contact us directly.','error');
      }
    };

    xhr.onerror = function() {
      showMessage('Something is broken, please try it later or contact us directly.', 'error');
      formSubmit.removeAttribute('disabled', 'disabled');
      formSubmit.innerText = 'Send message';
    };
  });
}

document.addEventListener("DOMContentLoaded", function() {
  var contactForms = document.getElementsByClassName('js-contact-form');
  for (var i = 0; i < contactForms.length; i++) {
    if(contactForms.hasOwnProperty(i)){
      initContactForm(contactForms[i]);
    }
  }
});
